<div class="tumbnail-browser-container" [class.mobile-preview]="isMobilePreview">
  @if (!isMobilePreview) {
    <div class="tumbnail-browser__header">
      <div class="tumbnail-browser__header__column tumbnail-browser__header__column--left">
        <span class="dot dot-1"></span>
        <span class="dot dot-2"></span>
        <span class="dot dot-3"></span>
      </div>
      <div class="tumbnail-browser__header__column tumbnail-browser__header__column--middle">
        <div class="url-bar"></div>
      </div>
      <div class="tumbnail-browser____header__column tumbnail-browser__header__column--right">
        <mat-icon>more_vert</mat-icon>
      </div>
    </div>
  }

  @if (isGenerating) {
    <ng-container *ngTemplateOutlet="thumbnailBrowserContent"></ng-container>
  } @else {
    <a
      href
      [routerLink]="crossAccountNavService.isOtherAccount(siteId) ? null : settingsLink"
      (click)="crossAccountNavService.handleLinkClick($event, siteId, settingsLink, siteName)">
      <ng-container *ngTemplateOutlet="thumbnailBrowserContent"></ng-container>
    </a>
  }
</div>

<ng-template #thumbnailBrowserContent>
  <div class="tumbnail-browser__content">
    <div
      class="ratio-4-3"
      [ngClass]="(showThumbnail ? 'widget-position--' + campaignImg.position : 'default-preview-image') + (isAbTestCampaign ? ' isAbTest' : '')"
      [class.isloading]="isGenerating || isUpdating">
      @if (isGenerating || isUpdating) {
        <div class="loading">
          <mat-progress-spinner mode="indeterminate" [ngClass]="isDarkTheme ? 'white-spinner' : 'black-spinner'"></mat-progress-spinner>
          <span class="text">{{ "generic.generating" | translate }}...</span>
        </div>
      } @else {
        @if (showThumbnail) {
          @if (!isDarkTheme) {
            <img
              [src]="campaignImg.imageUrl"
              onError="this.src='/assets/img/campaign/preview_no_image.png'"
              class="preview-image"
              [class.mobile-preview-image]="isMobilePreview" />
          }
          @if (isDarkTheme) {
            <img
              [src]="campaignImg.imageUrl"
              onError="this.src='/assets/img/campaign/thumbnail-darkmode.png'"
              class="preview-image"
              [class.mobile-preview-image]="isMobilePreview" />
          }
        } @else {
          <img
            [src]="!isDarkTheme ? '/assets/img/campaign/preview_no_image.png' : '/assets/img/campaign/thumbnail-darkmode.png'"
            class="preview-image"
            [class.mobile-preview-image]="isMobilePreview" />
        }
      }
    </div>
  </div>
</ng-template>
